import { ReactNode } from "react";
import { BlogNav } from "./BlogNav";
import { Footer } from "./Footer";

interface BlogPageLayoutProps {
  children: ReactNode;
}

export function BlogPageLayout({ children }: BlogPageLayoutProps) {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <BlogNav />
      <main className="pt-24">
        {children}
      </main>
      <Footer variant="light" />
    </div>
  );
}
